export const getUserInitials = (user) => {
  if (!user) return null;
  if (typeof user === "string") {
    let initials = ""
    const names = user.split(" ").filter((name) => !!name)
    if (names[0]) initials = names[0][0];
    if (names.length > 1) {
      initials += names[names.length - 1][0]
    }
    return initials.toUpperCase()
  }
  return null
}